import 'arrive';
import $ from 'jquery';

document.arrive('.menu-toggle', {existing: true}, function(){
    $(this).click((e) => {
        e.stopPropagation();
        $('#main-header').toggleClass('_active');
    });
});
document.arrive('.mnt-language-switcher, .language-switcher-sidebar__overlay', {existing: true}, function(){
    $(this).click((e) => {
        e.stopPropagation();
        e.preventDefault();
        $('.language-switcher-sidebar').toggleClass('_active');
    });
});

// $(document).ready(() => {
//     $(window).scroll(() => {
//         var scroll = $(window).scrollTop();
//         var $header = $('header.navbar');
//         if (scroll >= $header.height()) {
//             $header.addClass('sticky');
//         } else {
//             $header.removeClass('sticky');
//         }
//     });
// });